<template>
  <v-menu
    v-model="menuExpanded"
    transition="slide-y-transition"
    :location="$attrs['general-actions'] ? 'bottom' : 'left'"
    :offset="$attrs['general-actions'] ? 10 : 0"
  >
    <template #activator="{ props }">
      <v-icon
        :class="$attrs['general-actions'] ? 'ml-2' : ''"
        class="three-dot-menu"
        :data-cy="
          $attrs['general-actions']
            ? 'general-three-dot-menu'
            : 'three-dot-menu'
        "
        v-bind="props"
        :color="$attrs['general-actions'] ? 'black' : colors.disabledInputs"
      >
        mdi-dots-vertical
      </v-icon>
    </template>
    <ActionButtonList
      :config="filteredActionsButtonConfig()"
      :item="item"
      :posthogActionData="{ dataTableId: dataTableId, numSelectedElements: 0 }"
    />
  </v-menu>
</template>

<script lang="ts">
import { deviceThreeDotMenuPatch } from '@/models/inventory/deviceTableConfig';
import { merge } from 'lodash';
import { defineComponent } from 'vue';
import {
  ActionsButtonWithCallback,
  ActionTypes,
  ButtonCallbacks
} from '@/components/types/DataTable';
import ActionButtonList from './ActionButtonList.vue';
import { colors } from '@/styles/colors';

export default defineComponent({
  name: 'ThreeDotMenu',
  components: { ActionButtonList },

  props: {
    config: {
      type: Array as () => ActionsButtonWithCallback[],
      required: true
    },
    item: {
      type: Object as () => Record<string, unknown>,
      required: false,
      default: () => ({})
    },
    dataTableId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      menuExpanded: false,
      selectionType: this.$attrs['general-actions']
        ? ActionTypes.NONE
        : ActionTypes.SINGLE,
      colors
    };
  },
  methods: {
    isAction(action: ActionsButtonWithCallback): boolean {
      return action.id !== ButtonCallbacks.NONE;
    },
    filteredActionsButtonConfig(): ActionsButtonWithCallback[] {
      const filteredConfig = this.config.filter(
        (actionButton) =>
          actionButton.types.includes(this.selectionType) &&
          !actionButton.primary
      );
      filteredConfig.map((actionButton) => {
        if (actionButton.id === deviceThreeDotMenuPatch.id) {
          merge(actionButton, deviceThreeDotMenuPatch);
        }
      });
      return filteredConfig;
    }
  }
});
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.action-list {
  background-color: colors.$table-header;
}

tr:hover .three-dot-menu {
  color: black !important;
}
</style>
